import { convertToLocalTime } from 'date-fns-timezone';
import { format } from 'date-fns';

const convertToISO = dateString => `${dateString.replace(/ /g, 'T')}`;

const convertToLocal = (dateString) => {
  const iso = convertToISO(dateString);
  const local = convertToLocalTime(iso, { timeZone: 'UTC' });
  return local;
};

const formatDate = dateString => format(convertToLocal(dateString), 'yyyy-MM-dd HH:mm');

export { convertToLocal, formatDate, convertToISO }; // eslint-disable-line